import $ from 'static/script/libs/jquery';
import _ from 'static/script/libs/underscore';
import defineComponent from 'flight';
import ajax from 'static/script/app/data/ajax';
import antiForgeryToken from 'static/script/app/data/anti-forgery-token';

function ScribeTransport() {
    this._data = [];

    this.defaultAttrs({
        endpointUrl: '/scribe',
        client: '',
        page: '',
        area: '',
        path: '',
        context: null
    });

    this._prepare = function (evt, payload) {
        if (payload === null || payload === '') {
            return;
        }

        payload.context = this.attr.context;

        let data = JSON.stringify(payload);
        data = data.replace(/</gi, '{');
        data = data.replace(/>/gi, '}');

        this._queue(data);
    };

    this._queue = function (data) {
        this._data.push(data);
        this.trigger('data:scribe:on-send');
    };

    this.after('initialize', function () {
        let debounceSendData = _.debounce(function () {
            let options = {
                url: this.attr.endpointUrl,
                type: 'POST',
                data: { entries: '[' + this._data.toString() + ']' },
                async: true
            };

            antiForgeryToken.addToAjaxRequest(options);

            ajax(options);
            this._data.length = 0;
        }, 500);

        this.on('data:scribe:on-send', debounceSendData);
        this.on('data:scribe', this._prepare);
    });
}

module.exports = defineComponent.component(ScribeTransport);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/scribe-transport.js